import * as Yup from 'yup'
import { Col, Form, Row } from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    entranceDate: checkRequiredText(settings),
    hourlyWage: checkRequiredText(settings),
});

export const EntranceDateSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formEntranceDate">
                <Form.Label>Wann möchtest du bei uns beginnen?*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Eintrittsdatum eingeben"
                    type="text"
                    name="entranceDate"
                    value={values.entranceDate}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.entranceDate && !errors.entranceDate}
                    isInvalid={touched.entranceDate && errors.entranceDate}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.entranceDate}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formHourlyWage">
                <Form.Label>Welchen Stundenlohn stellst du dir vor?*</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Stundenlohn eingeben"
                    type="text"
                    name="hourlyWage"
                    value={values.hourlyWage}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.hourlyWage && !errors.hourlyWage}
                    isInvalid={touched.hourlyWage && errors.hourlyWage}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.hourlyWage}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};